import React from "react";
import styles from "./JoinSection.module.css";
import Frame from "../../Assets/Stories1.png"; // This is your full image
import Line from '../../Assets/Vector1.png'
import { CheckCircle } from "lucide-react";
const JoinSection = () => {
    const features = [
    { text: "Short, simple, and trustworthy news" },
    { text: "No unnecessary ads or clutter" },
    { text: "Real-time trending news and videos" },
    { text: "User-friendly design" },
    { text: "Clean and minimal interface" },
    { text: "Fast and responsive experience" },
  ];

  return (
    <section className={styles.container}>
      <h2 className={styles.title}>WHY SS MEDIA</h2>
      <div className={styles.grid}>
        {features.map((feature, index) => (
          <div key={index} className={styles.card}>
            <CheckCircle className={styles.icon} />
            <span>{feature.text}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default JoinSection;
